let bcpoDoneCalled = false;
function bcpoDone() {

  if (bcpoDoneCalled) return; // If the function has already been called, exit immediately
  bcpoDoneCalled = true; // Set the flag to indicate that the function has been called

  /* if($('.bcpo-title:contains("Add an Incription:"):last').length > 0){
    $('.bcpo-title:contains("Add an Incription:"):last').text('Add an Inscription:')
  }
  if($('input[name="properties[Add an Incription]"]').length > 0 ){
    $('input[name="properties[Add an Incription]"]').attr("name", "properties[Add an Inscription]")
  } */

  if($('.bcpo-title:contains("Add an Inscription (*stamped on inside):"):last').length > 0){
    $('.bcpo-title:contains("Add an Inscription (*stamped on inside):"):last').text('Add an Inscription (*stamped on inside):')
  }
  if($('input[name="properties[Add an Inscription (*stamped on inside)]"]').length > 0 ){
    $('input[name="properties[Add an Inscription (*stamped on inside)]"]').attr("name", "properties[Add an Inscription (*stamped on inside)]")
  }
  

  if( $('input[name="properties[Add an Inscription (*stamped on inside)]"]').length > 0 && $('.product__info-wrapper').attr('data-inc-tag') != ''){
    var inc_tag_name = $('.product__info-wrapper').attr('data-inc-tag');
    if(inc_tag_name == "spurs_inscription"){
      let SpurIncImg = '';
      
          SpurIncImg = '//tombalding.com/cdn/shop/files/spur_incription.webp?v=1722572908';
      
      if(SpurIncImg != ''){
        $('input[name="properties[Add an Inscription (*stamped on inside)]').parent().append('<div class="image_wrapper"><img src="'+SpurIncImg+'" class="incription__image inscription__img_pop" id="incription_image"/></div>');    
      }
    }else if(inc_tag_name == "bits_inscription"){
      let BitIncImg = '';
      
          BitIncImg = '//tombalding.com/cdn/shop/files/BIT_INSCRIPTION_STAMPED_2_b80fb985-c7e9-4536-9cee-d4853e005c11.webp?v=1722572908';
      
      if(BitIncImg != ''){
        $('input[name="properties[Add an Inscription (*stamped on inside)]"]').parent().append('<div class="image_wrapper"><img src="'+BitIncImg+'" class="incription__image inscription__img_pop" id="incription_image"/></div>');    
      }
    } 
  }
  let SilverlettersImg = '';
  
      SilverlettersImg = '//tombalding.com/cdn/shop/files/silver_letter.webp?v=1722572948';
  
  if($('input[name="properties[3/16” silver letters ($16 per letter)]"]').length > 0 && SilverlettersImg != ''){
    $('input[name="properties[3/16” silver letters ($16 per letter)]"]').parent().append('<div class="image_wrapper"><img src="'+SilverlettersImg+'" class="incription__image silver__img_pop" id="incription_image"/></div>');
  }

  // Incription Image popup js 
  // $('.incription__image').click(function() {
  //   var imageSrc = $(this).attr('src');
  //   $('.incription_image_popup .image_wrapper #incription_image').attr('src' , imageSrc);
  //   $('.incription_image_popup').addClass('active');
  // })
  // $('.incription_image_popup_close_btn').click(function() {
  //   $('.incription_image_popup').removeClass('active');
  // })
}
$(document).on("click",".incription__image",function() {
  var imageSrc = $(this).attr('src');
  $('.incription_image_popup .image_wrapper #incription_image').attr('src' , imageSrc);
  $('.incription_image_popup').addClass('active');
});
$(document).on("click",".incription_image_popup_close_btn",function() {
  $('.incription_image_popup').removeClass('active');
})